<div class="login-box">
  <h2 class="reset-header">{{ "RESET_PASSWORD_HEADER" | translate }}</h2>
  <p class="reset-desc" *ngIf="!linkExpired">
    {{ "RESET_PASSWORD_DESC" | translate }}
  </p>
  <p class="reset-desc mb-3" *ngIf="linkExpired">
    {{ "LINK_EXPIRED" | translate }}
  </p>
</div>
<div class="reset-form-elements" *ngIf="!linkExpired">
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="email-section">
      <img
        src="./assets/icons/login-email-logo.svg"
        alt="Email section"
        draggable="false"
      />
      <mat-form-field appearance="fill">
        <input
          type="email"
          matInput
          formControlName="emailFormControl"
          placeholder="{{ 'EMAIL_PLACEHOLDER' | translate }}"
        />
        <mat-error
          *ngIf="
            form.controls['emailFormControl'] &&
            form.controls['emailFormControl'].hasError('pattern')
          "
        >
          {{ "INVALID_EMAIL" | translate }}
        </mat-error>
        <mat-error
          *ngIf="form.controls['emailFormControl'].hasError('required')"
        >
          {{ "EMAIL_REQUIRED" | translate }}
        </mat-error>
        <mat-error
          *ngIf="form.controls['emailFormControl'].hasError('userDoesNotExist')"
          >{{ "EMAIL_NOT_EXISTS" | translate }}
        </mat-error>
        <mat-error
          *ngIf="form.controls['emailFormControl'].hasError('IPError')"
          >{{ "IP_ERROR" | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="mx-2">
      <re-captcha
      (resolved)="addTokenLog('Normal mode resolved', $event)"
      formControlName="recaptcha"
    ></re-captcha>
    <div
      [hidden]="
        form.controls['recaptcha'] &&
        !form.controls['recaptcha'].hasError('required')
      "
      class="error"
    >
      {{ "CAPTCHA_REQUIRED" | translate }}
    </div>
    </div>
    <div class="align-reset-btn">
      <button
        type="submit"
        class="btn blue-gredient-btn form-control w-100 justify-content-center"
        mat-button
        mat-flat-button
      >
        {{ "RESET_BTN" | translate }}
      </button>
    </div>
  </form>
</div>
<p class="botom-action-line">
  {{ "BACK_TITLE" | translate }}
  <span routerLink="" class="login-now">{{
    "RESET_BACK_TO_LOGIN" | translate
  }}</span>
</p>
